import React from 'react'
import FilterTagsPc from '../FilterTags/FilterTagsPc';
import { SelectProps } from 'antd';

export interface ClientTagsPcProps extends SelectProps {
    tagType?:'client'
}

function FilterClientTagsPc(props:ClientTagsPcProps) {
    const { tagType='client', ...rest } = props;
    return <FilterTagsPc
    tagType={tagType} 
    {...rest}
        />
}

export default FilterClientTagsPc